// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"9717":"de0af05d18d98ded","9979":"d9a59d1486ad98cb"}[chunkId] + ".js";
};